import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=6d720c58&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"
import style0 from "./Password.vue?vue&type=style&index=0&id=6d720c58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d720c58",
  null
  
)

export default component.exports